import { PropsWithChildren, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { localizationStore } from '@stores/localization';

export const I18nProvider = observer(({ children }: PropsWithChildren) => {
  const language = localizationStore.language;

  useEffect(() => {
    // Giosg determines the chat language from this value. Chat will not work if this is not set.
    window.OmaSATOLanguage = language;
  }, [language]);

  /*
   * update document <html /> lang attribute on language change for screen readers
   * See more: https://dequeuniversity.com/rules/axe/4.8/html-has-lang
   */
  useEffect(() => {
    const htmlElements = document.getElementsByTagName('html');

    htmlElements.item(0)?.setAttribute('lang', language);
  }, [language]);

  return children;
});
